export const PAYMENT = {
  CASH: "COD",
  CREDIT_CARD: "CCOD",
  PREPAID: "CARD",
};
export const PAYMENT_STATUS = {
  PREPAID: "PREPAID",
  UNPAID: "UNPAID",
};
export const PAYFORT_STATUS = {
  SUCCESS: "18",
};

export const PAYFORT_3DS_STATUS = {
  SUCCESS: "14000",
  TRANSACTION_DECLINED: "666",
  INSUFFICIENT_FUNDS: "029",
  INVALID_CARD_NUMBER: "016",
  CARD_EXPIRED: "012"
};

export const VALIDATION_TYPES = {
  ITEM: "ITEM",
  MODIFIER_GROUP: "MODIFIER_GROUP",
  MODIFIER: "MODIFIER"
};

export const VALIDATION_TYPE_NAMES = {
  ITEM: "Menu Item",
  MODIFIER_GROUP: "Modifier Group",
  MODIFIER: "Modifier"
};

export const VALIDATION_TYPE_DISPLAY = {
  [VALIDATION_TYPES.ITEM]: VALIDATION_TYPE_NAMES.ITEM,
  [VALIDATION_TYPES.MODIFIER_GROUP]: VALIDATION_TYPE_NAMES.MODIFIER_GROUP,
  [VALIDATION_TYPES.MODIFIER]: VALIDATION_TYPE_NAMES.MODIFIER
};

export const VALIDATION_STATUS = {
  NOT_APPLICABLE: "NOT_APPLICABLE",
  VALID: "VALID",
  MISSING: "MISSING",
  INVALID: "INVALID"
};

export const VALIDATION_FIELD_TYPES = {
  IMAGE: "image",
  PRICE: "price",
  DESCRIPTION: "description",
  DESCRIPTION_TRANSLATION: "descriptionTranslation",
  NAME_TRANSLATION: "nameTranslation"
};

export const VALIDATION_FIELD_NAMES = {
  [VALIDATION_FIELD_TYPES.IMAGE]: "Image",
  [VALIDATION_FIELD_TYPES.PRICE]: "Price",
  [VALIDATION_FIELD_TYPES.DESCRIPTION]: "Description",
  [VALIDATION_FIELD_TYPES.DESCRIPTION_TRANSLATION]: "Description Translation",
  [VALIDATION_FIELD_TYPES.NAME_TRANSLATION]: "Name Translation"
};